import axios from "axios";
export const SET_CURRENCY = "SET_CURRENCY";

export const setCurrency = (currencyName) => {
  return (dispatch) => {
    axios
      .get(`https://api.exchangeratesapi.io/latest?base=USD`)
      .then((response) => {
        const rates = response.data.rates;
        let currencyRate = 0;
        for (const rate in rates) {
          if (rate === currencyName) {
            currencyRate = rates[rate];
          }
        }

        // 手动映射货币符号
        const currencySymbols = {
          HKD: "HK$",
          USD: "US$",
          CNY: "¥",
          EUR: "€",
        };
        const currencySymbol = currencySymbols[currencyName] || "$";

        dispatch({
          type: SET_CURRENCY,
          payload: { 
            currencyName, 
            currencyRate,
            currencySymbol, // 确保存储货币符号
          },
        });
      })
      .catch((err) => {
        console.log("Error: ", err);
        // 如果 API 失败，仍然设置默认货币符号
        dispatch({
          type: SET_CURRENCY,
          payload: { 
            currencyName, 
            currencyRate: 1, // 默认汇率
            currencySymbol: currencyName === "HKD" ? "$" : "$",
          },
        });
      });
  };
};